<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row max-h-screen overflow-y-auto overflow-x-hidden">
      <div class="flex flex-col gap-2 w-full self-center">
        <h2 class="text-chathams-blue font-bold text-2xl text-center pl-2">
          Marcar consulta para o dia {{ appointmentDate | date: 'dd/MM/yyyy' }}
        </h2>

        <div class="flex flex-col p-2 ml-12">
          <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
            <table class="min-w-full">
              <thead class="border-b border-gray-400">
                <tr class="text-left uppercase text-chathams-blue font-medium">
                  <th scope="col" class="p-2">Colaborador</th>
                  <th scope="col" class="p-2">Horários Preferidos</th>
                  <th scope="col" class="p-2">Modalidade</th>
                  <th
                    scope="col"
                    class="p-2 font-bold tracking-wider text-center uppercase text-chathams-blue"
                    *isAllowed="[ERoleAdminString.Doctor, 'appointments.create']"
                  >
                    Mais
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  class="bg-white hover:bg-iceberg text-left font-medium text-sm text-chathams-blue"
                  *ngFor="let consulta of consultas"
                  [ngClass]="{ 'bg-downy': consulta.id === medicalAppointmentRequestIdValue }"
                >
                  <td class="p-2">
                    {{ consulta.employee.name }}
                  </td>
                  <td class="p-2">
                    {{ consulta.preferredTimes }}
                  </td>
                  <td class="p-2">
                    {{ consulta.modality | modalidadeConsulta }}
                  </td>

                  <td
                    class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md"
                    *isAllowed="[ERoleAdminString.Doctor, 'appointments.create']"
                  >
                    <button
                      class="p-2 text-sm bg-chathams-blue hover:bg-chathams-blue-700 text-white rounded"
                      (click)="selectRequestId(consulta.id, consulta.employeeId)"
                    >
                      Selecionar
                    </button>
                  </td>
                </tr>
                <tr *ngIf="!consultas.length">
                  <td colspan="4">Nenhuma solicitação de consulta para esse dia</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <div class="flex justify-end my-5">
            <app-paginacao
              [numeroDeItens]="dadosPaginacao.itensTotal"
              [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
              [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
              [totalPage]="dadosPaginacao.totalPaginas"
              [opcaoItensPagina]="[6]"
              (mudouPagina)="mudouPagina($event)"
              (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
            ></app-paginacao>
          </div>
        </div>
      </div>

      <div
        class="w-full flex gap-5 p-3 lg:px-5 justify-end sm:gap-3 sm:flex-wrap flex-col bg-iceberg menu lg:h-auto sm:w-auto"
      >
        <button class="w-12 self-end h-10 rounded-sm lg:top-5 right-10 btn--secondary" (click)="hideModalConsulta()">
          X
        </button>

        <div class="flex flex-col px-4 lg:px-0 pb-3 pt-6 gap-2 w-full lg:w-64">
          <form [formGroup]="form" class="w-full">
            <div class="flex flex-col gap-2">
              <div class="" *ngIf="!isDoctor">
                <label for="duration" class="input-label">Atendente</label>
                <select class="form-input w-full" formControlName="doctorId">
                  <option *ngFor="let doctor of doctors" [value]="doctor.id">{{ doctor.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="duration" class="input-label">Duração consulta</label>
                <select class="form-input w-full" formControlName="duration">
                  <option *ngFor="let duracao of durations" [value]="duracao.value">
                    {{ duracao.label }}
                  </option>
                </select>
              </div>
            </div>
          </form>
          <span class="font-bold text-blumine text-sm">Selecione o horário</span>
          <div class="overflow-auto" [ngClass]="{ 'h-64': !isDoctor, 'h-80': isDoctor }">
            <mwl-calendar-day-view
              [viewDate]="appointmentDate"
              [events]="events"
              [locale]="locale"
              [hourSegments]="4"
              [dayStartHour]="8"
              [dayEndHour]="22"
              [eventTemplate]="dayView"
              [hourSegmentHeight]="35"
              style="width: 100%"
              (hourSegmentClicked)="selectTime($event)"
            >
            </mwl-calendar-day-view>
            <ng-template #dayView let-dayEvent="weekEvent">
              <app-consulta-agenda [event]="dayEvent.event"></app-consulta-agenda>
            </ng-template>
          </div>
        </div>
        <button class="sm:px-2 self-end sm:self-center lg:mb-5 btn w-48 btn--secondary" (click)="agendarConsulta()">
          Agendar Consulta
        </button>
      </div>
    </div>
  </div>
</div>
